module.exports = __webpack_public_path__ + "static/media/fall.7026e680.svg";